import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowsDiagonalOutOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="M10.128 6.862 13.6 3.39v2.977H15V1H9.633v1.4h2.977L9.138 5.872z" fill="currentColor" />
                <path d="m3.39 13.6 3.472-3.472-.99-.99L2.4 12.61V9.633H1V15h5.367v-1.4z" fill="currentColor" />
            </g>
        </svg>
    )
);
ArrowsDiagonalOutOutlinedSize16Glyph.displayName = 'ArrowsDiagonalOutOutlinedSize16Glyph';
